﻿export class age_category {
    public name: string = "";
    public default_passengers: number = 0;
    public max_passengers: number = 0;
    public accompanied: boolean = false;
    //public selected_passengers: number;
}